// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import NewsmatcherView from "./components/NewsmatcherView";
import PasswordReset from "./components/auth/PasswordReset";
import { ConnectionProvider } from "./hooks/useConnection";
import { ConfigProvider } from "./hooks/useConfig";
import SimpleAssistantPage from "./pages/SimpleAssistant";
import ArticleSearchScreen from "./pages/ArticleSearchScreen";
import ArticleDetail from "./pages/ArticleDetail";
import DefaultLayout from "./components/DefaultLayout";
import { ChatProvider } from "./contexts/ChatContext";
import UnsubscribePage from "./pages/UnsubscribePage"; // import the new page

function App() {
  return (
    <>
      <PasswordReset />
      <ConnectionProvider>
        <ConfigProvider>
          <ChatProvider>
            <Routes>
              <Route
                path="/SimpleAssistant"
                element={
                  <ProtectedRoute>
                    <SimpleAssistantPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Newsmatcher"
                element={
                  <ProtectedRoute>
                    <NewsmatcherView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/search"
                element={
                  <ProtectedRoute>
                    <ArticleSearchScreen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/article/:doc_reference"
                element={
                  <ProtectedRoute>
                    <ArticleDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/unsubscribe"
                element={
                  <ProtectedRoute>
                    <UnsubscribePage />
                  </ProtectedRoute>
                }
              />
              <Route path="/*" element={<DefaultLayout />} />
            </Routes>
          </ChatProvider>
        </ConfigProvider>
      </ConnectionProvider>
    </>
  );
}

export default App;
